<footer class="footer" style="background-color: rgb(255, 255, 255);">
    <div class="container py-2 d-sm-none d-xs-none d-md-none d-lg-block d-none" style="height: 120px;">
        <div class="row">
            <div class="col-lg-4">
                <h5 class="text-black">Synergy</h5>
                <p class="small text-muted">Ofrecemos soluciones a la medida y de la m&aacute;s alta
                    calidad, perm&iacute;tanos
                    ser el mejor aliado tecnol&oacute;gico para el crecimiento de su negocio</p>
            </div>
            <div class="col-lg-2 d-sm-none d-xs-none d-md-none d-lg-block d-none">
                <h5 class="text-black"></h5>
                <ul class="list-unstyled  small text-muted " style="color: black !important;">
                    <li><a class="text-black" href="#">Inicio</a></li>
                    <li><a class="text-black" href="#">Acerca de</a></li>
                    <li><a class="text-black" href="#" [routerLink]="['/Contact']">Cont&aacute;tenos</a>
                    </li>
                </ul>
            </div>
            <div class="col-lg-2 d-sm-none d-xs-none d-md-none d-lg-block d-none">
                <h5 class="text-black"></h5>
                <ul class="list-unstyled  small text-muted " style="color: black !important;">
                    <li><a class="text-black" href="#">Ayuda</a></li>
                    <li><a class="text-black" href="#">Preguntas frecuentes</a></li>
                </ul>
            </div>
            <div class="col-lg-4 d-sm-none d-xs-none d-md-none d-lg-block d-none">
                <h5 class="text-black">Newsletter</h5>
                <p class="small text-muted">Susbcribase a nuestro bolet&iacute;n para obetener
                    informaci&oacute;n y noticias
                    sobre nuestros productos.
                <syn-subscription (onSubmit)="onSubscribe($event)" [ApplicationId]="applicayionId"></syn-subscription></p>
            </div>
        </div>
    </div>

    <!-- social media -->
    <div class="text-center text-black d-sm-none d-xs-none d-md-none d-lg-block d-none">
        <a href="#"> <i class="fa fa-facebook p-2"></i></a>
        <a href="#"> <i class="fa fa-instagram p-2"></i></a>
        <a href="#"> <i class="fa fa-youtube p-2"></i></a>
    </div>
    <!-- social media -->

    <!-- Copyright -->
    <div class="row">
        <div class="text-center  small text-muted" style="background-color: rgba(2, 29, 48, 0.953);">
            © {{year}} Todos los derechos reservados:
            <a class=" small text-muted " style="color: white !important;" href="http://synergytechnology.net">Synergy
                Technology</a>
        </div>
    </div>
    <!-- Copyright -->
</footer>
<p-toast [style]="{marginTop: '100px'}" position="top-center" key="tc" [hideTransitionOptions]="'1ms'">
</p-toast>